































































































































































































import VueOptions from '@utils/VueOptions'
import ChartUtility from '@utils/ChartUtility'
import DashboardView from '@ui/Dashboard/Layout/DashboardView'
import OrganizerDashboardHeader from '@ui/Dashboard/Views/Organizer/OrganizerDashboardHeader'
import RecapsBarChart from '@ui/Dashboard/Charts/Recaps/RecapsBarChart'
import OrganizerOffersBarChart from '@ui/Dashboard/Charts/Organizer/OrganizerOffersBarChart'
import OrganizerOffersLineChart from '@ui/Dashboard/Charts/Organizer/OrganizerOffersLineChart'
import RecapsPhotosGallery from '@ui/Dashboard/Charts/Recaps/RecapsPhotosGallery'
import DemographicsGenderDoughnutChart from '@ui/Dashboard/Charts/Audience/Demographics/DemographicsGenderDoughnutChart'
import DemographicsRaceBarChart from '@ui/Dashboard/Charts/Audience/Demographics/DemographicsRaceBarChart'
import DemographicsAgeBarChart from '@ui/Dashboard/Charts/Audience/Demographics/DemographicsAgeBarChart'
import DemographicsEducationBarChart from '@ui/Dashboard/Charts/Audience/Demographics/DemographicsEducationBarChart'
import DemographicsIncomeBarChart from '@ui/Dashboard/Charts/Audience/Demographics/DemographicsIncomeBarChart'
import PersonasProfilesBarChart from '@ui/Dashboard/Charts/Audience/Personas/PersonasProfilesBarChart'

settings =
  name: 'OrganizerDashboardView'

  resources:
    dashboard:
      resourceName: 'dashboard'
      slug: 'dashboard/organizer'
      fetch: false

  vue:
    props: ['organizer', 'options']

    components: {
      DashboardView,
      OrganizerDashboardHeader,
      RecapsBarChart,
      OrganizerOffersBarChart,
      OrganizerOffersLineChart,
      RecapsPhotosGallery,
      DemographicsGenderDoughnutChart,
      DemographicsRaceBarChart,
      DemographicsAgeBarChart,
      DemographicsEducationBarChart,
      DemographicsIncomeBarChart,
      PersonasProfilesBarChart,
    }

    # computed:
      # dueNowAlerts: ->
      #   [
      #     { title: 'Pending Offers', count: 5 }
      #     { title: 'Missing Shipping', count: 2 }
      #     { title: 'Overdue Recaps', count: 2 }
      #     { title: 'Not Submitted Recaps', count: 2 }
      #     { title: 'Missing Bank Account', count: 2 }
      #   ]

      # dueLaterAlerts: ->
      #   [
      #     { title: 'Pending Recaps', count: 5, link: '#' }
      #     { title: 'Setup your experiences', link: '#' }
      #     { title: 'Setup your reach', link: '#' }
      #     # { title: 'Setup your capacity', link: '#' }
      #     { title: 'Publish your listings', link: '#', count: 7 }
      #     { title: 'Setup your min payout', link: '#', action: 'no_min_payout' }
      #     { title: 'Create an omnichannel asset', link: '#', action: 'we_don\'t_have_any' }
      #     # { title: 'Create a category Package asset', link: '#', action: 'we_don\'t_have_any' }
      #     # { title: 'Setup Special Storage', link: '#', action: 'we_don\'t_have_any' }
      #   ]

    methods:
      hiApplyFilter: ({ target }) ->
        @clearDataForResourceKey 'dashboard'
        @fetch 'dashboard', { target }

      resolveNumber: (dotPath) ->
        ChartUtility.resolveNumber @dashboard, dotPath

export default VueOptions.vue settings
